import EmailReminderEntrySource from '../store/schema/EmailReminderEntrySource';
import emailReminderStore from '../store/store';
import logInboxReminderOffsetOption from '../utils/logInboxReminderOffsetOption';
import { logUsage } from 'owa-analytics';
import { updateCalendarEventByEmailReminders } from '../actions/publicActions';
import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { trace } from 'owa-trace';
import { orchestrator } from 'satcheljs';
import {
    appendToInboxReminders,
    appendToInboxRemindersStoreUpdate,
    removeInboxReminder,
    removeInboxReminderStoreUpdate,
    replaceMatchingReminder,
    replaceMatchingReminderStoreUpdate,
    convertToServiceInboxReminders,
} from '../actions/inboxRemindersActions';
import {
    addToNewReminderIdMap,
    resetNewReminderIdMap,
    removeFromNewReminderIdMap,
} from '../actions/newReminderIdMapActions';

orchestrator(appendToInboxReminders, actionMessage => {
    const { inboxReminderToAppend, event, entrySource } = actionMessage;

    if (!event) {
        trace.error('appendToInboxReminders: event should not be null. entrySource:' + entrySource);
        return;
    }

    // local store update
    appendToInboxRemindersStoreUpdate(inboxReminderToAppend, event);
    addToNewReminderIdMap(inboxReminderToAppend.Id);

    // service update
    updateServiceInboxRemindersIfNecessary(event, entrySource);

    // Log changed reminder offset option
    tryLogReminderOffsetOption(inboxReminderToAppend.ReminderOffset, entrySource);
});

orchestrator(removeInboxReminder, actionMessage => {
    let { idToRemove, event, entrySource } = actionMessage;

    if (!event) {
        trace.error('removeInboxReminder: event should not be null. entrySource:' + entrySource);
        return;
    }

    // Update inbox reminders in local store
    removeInboxReminderStoreUpdate(idToRemove, event);

    // Try remove the reminder from the new reminder id map
    removeFromNewReminderIdMap(idToRemove);

    // Update inbox reminders on server
    updateServiceInboxRemindersIfNecessary(event, entrySource);
});

orchestrator(replaceMatchingReminder, actionMessage => {
    const { reminder, event, entrySource } = actionMessage;

    if (!event) {
        trace.error('removeInboxReminder: event should not be null. entrySource:' + entrySource);
        return;
    }

    // Update inbox reminders in local store
    replaceMatchingReminderStoreUpdate(reminder, event);

    // Update inbox reminders on server
    updateServiceInboxRemindersIfNecessary(event, entrySource);

    // Log changed reminder offset option
    tryLogReminderOffsetOption(reminder.ReminderOffset, entrySource);
});

function updateServiceInboxRemindersIfNecessary(
    event: CalendarEvent,
    entrySource: EmailReminderEntrySource
) {
    const inboxReminders = event.InboxReminders;
    // If the updates is from Reading Pane, client will directly issue UpdateItem service call to update the calendar eventItem.
    // For other cases like if the update is from Compose, the service update will be batched in compose actions.
    if (entrySource === EmailReminderEntrySource.ReadingPane) {
        // Convert the client inbox reminders to service type by wiping out the Id of new reminders
        const newReminderIds = Object.keys(emailReminderStore.newReminderIdMap);
        convertToServiceInboxReminders(newReminderIds, inboxReminders);

        updateCalendarEventByEmailReminders(
            event,
            {
                InboxReminders: inboxReminders,
            } as CalendarEvent /* calendarEventUpdates */
        );

        // For inbox reminder update from details form, log the total number of inbox reminders.
        // Compose form update is done through the common metrics helper function getEventMetricProperties.
        const numOfInboxReminders = inboxReminders ? inboxReminders.length : 0;
        logUsage('UpdateInboxRemindersFromDetailsForm', {
            numOfInboxReminders: numOfInboxReminders,
        });
    }

    // Reset the new reminder id map after the service call has been issued
    resetNewReminderIdMap();
}

function tryLogReminderOffsetOption(reminderOffset: number, entrySource: EmailReminderEntrySource) {
    // If the add/update is from details form, log the reminder option
    if (entrySource === EmailReminderEntrySource.ReadingPane) {
        logInboxReminderOffsetOption(reminderOffset);
    }
}
